
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolios/[slug]",
      function () {
        return require("private-next-pages/portfolios/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolios/[slug]"])
      });
    }
  